import { generateJsxKey, parseStyleAttribute, printAST } from '@utils/ast';
import { iGuideHtmlNodeLatexPrinters } from './spec.html.js';
import ContextImage from './spec.image.comp.js';
import { jsx } from 'react/jsx-runtime';

const imageParsers = {
  img: node => {
    const src = node.getAttribute("src");
    const alt = node.getAttribute("alt") || undefined;
    const width = parseInt(node.getAttribute("width") ?? "");
    const height = parseInt(node.getAttribute("height") ?? "");
    const style = parseStyleAttribute(node.getAttribute("style"));
    const cssWidth = style?.["width"];
    const latex = node.getAttribute("data-latex");
    return {
      nodeType: "img",
      src,
      alt,
      latex,
      cssWidth,
      dimensions: {
        width: Number.isNaN(width) ? undefined : width,
        height: Number.isNaN(height) ? undefined : height
      }
    };
  }
};
const imagePrinters = {
  img: (node, context) => {
    return /*#__PURE__*/jsx(ContextImage, {
      node: node
    }, generateJsxKey(context));
  }
};
const imageToLatexPrinters = {
  img: node => {
    if (!node.caption) {
      return `\\includegraphics[width=\\textwidth]{${node.src}}`;
    }
    const caption = printAST(node.caption, {
      ...iGuideHtmlNodeLatexPrinters
    });
    return `\\begin{figure}
\\includegraphics[width=\\textwidth]{${node.src}}
\\caption{${caption}}
\\end{figure}
`;
  }
};

export { imageParsers, imagePrinters, imageToLatexPrinters };
//# sourceMappingURL=spec.image.js.map
